import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";
import * as Constants from "@/constants";

const formSchema = z.object({
  first_name: stringSchema({ key: "First Name", required: true }),
  last_name: stringSchema({ key: "Last Name", required: true }),
  email: stringSchema({ type: "email", key: "Email", required: true }),
  title: stringSchema({ key: "Title", required: true }),
  role_ids: z.union([z.string(),z
    .array(z.string())
    .min(1, Constants.INPUT_ERRORS.REQUIRED("Access Level"))]),
  account_ids: z.array(z.string()).optional().nullable(),
  country_ids: z.array(z.string()).optional().nullable(),
  time_zone: stringSchema({ key: "Time Zone", required: true }),
  status: z.string().optional().nullable(),
  mailer: z.boolean(),
  metis_mailer: z.boolean(),
  rating_mailer: z.boolean(),
  quality_mailer: z.boolean(),
  client_admin: z.boolean().optional().nullable(),
});

export default formSchema;
